import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import {
  returnBlockValue,
  returnUserContent,
} from '@/utils/op-types/helperFunctions'

// store
import {
  manifestBlocks,
  pageContentBlocks,
  userContents,
} from '@/utils/op-types/store'

// components
import Input from '@/components/optypes/headlesss-components/Input'

const Block1Test = ({ id, block, design, content }) => {
  // manifest settings
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [getUserContents, setUserContents] = useAtom(userContents)

  function updateUserContent(key, newValue) {
    const nextState = produce(getUserContents, draft => {
      draft[id][key] = newValue
    })
    setUserContents(nextState)
  }

  return (
    <div className="border border-gray-600 p-3 rounded mb-4">
      <div
        style={{
          color: returnBlockValue(
            'background',
            'design',
            opBlocks[block],
            design
          ),
        }}
        className="text-lg mb-3 font-bold"
      >
        {returnBlockValue('headline', 'content', opBlocks[block], content)}
      </div>

      <div className="mt-3">
        <Input
          value={returnUserContent('value', id, getUserContents)}
          updateValue={value => {
            updateUserContent('value', value)
          }}
          placeholder="placceeeeholdeerrrr"
        />
      </div>
    </div>
  )
}

export default Block1Test
